/* eslint-disable prefer-destructuring */

removeParam = (key, sourceURL) => {
    let rtn = sourceURL.split('?')[0];
        let param;
        let paramsArr = [];
        const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
    if (queryString !== '') {
        paramsArr = queryString.split('&');
        for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
            param = paramsArr[i].split('=')[0];
            if (param === key) {
                paramsArr.splice(i, 1);
            }
        }
        if (paramsArr.length) rtn = `${rtn}?${paramsArr.join('&')}`;
    }
    return rtn;
};

(($) => {
    const filters = $('.cf_tax_filter_size, .cf_tax_filter_material');

    if (filters.length) {

        filters.each((index, item) => {
            const title = jQuery(item).find('.widgettitle').text();
            $(item).find('select').prepend(`<option value="default" selected>${title}</option>`);
        });

        if (window.location.href.indexOf('vtc_pf_size') > -1) {
            const url = new URL(window.location.href);
            $(`.cf_tax_filter_size option[value=${url.searchParams.get('vtc_pf_size')}]`).attr('selected', 'selected');
        }

        if (window.location.href.indexOf('vtc_pf_material') > -1) {
            const url = new URL(window.location.href);
            $(`.cf_tax_filter_material option[value=${url.searchParams.get('vtc_pf_material')}]`).attr('selected', 'selected');
        }

        filters.change((e) => {
            const el = e.target;
            const val = $(el).val();
            let param = 'vtc_pf_material';
            let url = window.location.href;

            if ($(el).is('#lct-widget-vtc_size')) {
                param = 'vtc_pf_size';
            }

            if (val === 'default') {
                // eslint-disable-next-line no-console
                console.log(removeParam(param, url));
                window.location.href = removeParam(param, url);
                return;
            }

            if (url.indexOf(param) > -1) {
                let splitURL = window.location.href.split('?');
                url = splitURL[0];

                splitURL = splitURL[1].split('&');
                if (splitURL.length >= 2) {
                    jQuery.each(splitURL, (key, value) => {
                        if (value.indexOf(param) === -1) {
                            url += `?${value}`;
                        }
                    });
                }
            }

            if (url.indexOf('?') > -1) {
                url += `&${param}=${val}`;
            } else {
                url += `?${param}=${val}`;
            }
            window.location.href = url;
        });
    }
})(jQuery);
